import React, { useEffect, useMemo, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";

const useAccumulationCodeList = (
  onSelect,
  hideModal,
  initialSelectParams,
  intialSelectMode,
  initialLookupType,
  selectModeParamData = null,
  onNavigate
) => {
  const [data, setData] = useState([]);
  // const [paramsData, setParamsData] = useState({
  //   al1AccumulationCodeLst: "",
  // });
  const { axios_helper_no_header } = useAxios();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const {
    ACCUMULATION_CODE_LIST_ADD,
    ACCUMULATION_CODE_LIST_CODES,
    ACCUMULATION_CODE_LIST_EDIT,
    ACCUMULATION_CODE_LIST_DISPLAY,
    COPY_ACCUMULATION_CODE_LIST,
  } = ROUTE_PATHS;

  const screen_title = "Accumulation Code List";
  // const screenNumber = "RCAL1001";

  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);

  const {
    selectedSchedules = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      al1AccumulationCodeLst: "",
    },
  } = currentState;

  const [selectMode, setSelectedMode] = useState(intialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);

  const screenNumber = selectMode ? "RCAL1005" : "RCAL1001";

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(
    selectMode && lookupType !== "external"
      ? {
          al1AccumulationCodeLst:
            selectModeParamData?.al1AccumulationCodeLst ?? "",
        }
      : initialParamsData
  );

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]
      ?.al1AccumulationCodeLst;
  const updatedParamsData = {
    ...paramsData,
    al1AccumulationCodeLst: lastScheduleName,
  };

  const formFields = selectMode
    ? [
        {
          fieldLabel: "AL1 Accumulation Code Lst",
          name: "al1AccumulationCodeLst",
          label: "List",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
      ]
    : [
        {
          fieldLabel: "AL1 Accumulation Code Lst",
          name: "al1AccumulationCodeLst",
          label: "List",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
      ];

  const handleBack = () => {
    if (lookupType === "external" && selectMode) {
      window.parent.postMessage(
        {
          type: "hideModal",
        },
        "*"
      );
    } else {
      hideModal();
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Accumulation Code List",
          button_handeler: () => {
            navigateToPage(ACCUMULATION_CODE_LIST_ADD, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const menuOptions = useMemo(() => {
    return selectMode
      ? [
          {
            label: "Select",
            icon: <span className="material-icons">add</span>,
            command: () => {
              const paramDataMap = new Map();
              selectParams.forEach((key) => {
              if (rowData.hasOwnProperty(key["target"]) && key["source"]) {
                paramDataMap.set(key["source"], rowData[key["target"]]);
                }
              });
              const paramData = Object.fromEntries(paramDataMap);
              if (lookupType !== "external") {
                onSelect(paramData);
              } else {
                window.parent.postMessage(
                  { type: "responseData", data: paramData },
                  "*"
                );
              }
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              /*const message = {
                message: "navigate-to-presto",
                programCode: "RCAL1002",
                parameters: {
                  al1AccumulationCodeLst: rowData["al1AccumulationCodeLst"],
                  workInitialProgramMode: "DSP",
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");*/
              if (lookupType === "external") {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "ACCUMULATION_CODE_LIST_READ_ONLY",
                  schedulesDataKey: "selectedSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              } else {
                onNavigate({
                  data: { ...rowData },
                  target: ROUTE_PATHS.ACCUMULATION_CODE_LIST_DISPLAY,
                  navType: "local",
                  schedulesDataKey: "selectedCodes",
                  additionalData: {},
                });
              }
            },
          },
          {
            label: "Accumulation Codes",
            icon: <span className="material-icons">code</span>,
            command: () => {
              /* const message = {
                message: "navigate-to-presto",
                programCode: "RCAL2003",
                parameters: {
                  al1AccumulationCodeLst: rowData["al1AccumulationCodeLst"],
                  al1AccumCodeListDescr: rowData["al1AccumCodeListDescr"],
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");*/
              if (lookupType === "external") {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "CODES_IN_ACCUMULATION_CODE_LIST",
                  schedulesDataKey: "selectedSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              } else {
                onNavigate({
                  data: { ...rowData },
                  target: ROUTE_PATHS.ACCUMULATION_CODE_LIST_CODES,
                  navType: "local",
                  schedulesDataKey: "selectedCodes",
                  additionalData: {},
                });
              }
            },
          },
        ]
      : [
          {
            label: "Edit",
            icon: <span className="material-icons">edit</span>,
            command: () => {
              navigateToPage(ACCUMULATION_CODE_LIST_EDIT, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedCodes: selectedRows.length ? selectedRows : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Copy/Merge",
            icon: <span className="material-icons">content_copy</span>,
            command: () => {
              navigateToPage(COPY_ACCUMULATION_CODE_LIST, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedPriceSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                },
              ]);
            },
          },
          {
            label: "Delete",
            icon: <span className="material-icons">delete</span>,
            command: () => {
              openConfirmationModal();
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              navigateToPage(ACCUMULATION_CODE_LIST_DISPLAY, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedCodes: selectedRows.length ? selectedRows : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Accumulation Codes",
            icon: <span className="material-icons">code</span>,
            command: () => {
              navigateToPage(ACCUMULATION_CODE_LIST_CODES, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedCodes: selectedRows.length ? selectedRows : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
        ];
  });

  const columnDef = selectMode
    ? [
        {
          header: "List",
          field: "al1AccumulationCodeLst",
        },
        {
          header: "Description",
          field: "al1AccumCodeListDescr",
        },
      ]
    : [
        {
          header: "List",
          field: "al1AccumulationCodeLst",
        },
        {
          header: "Description",
          field: "al1AccumCodeListDescr",
        },
      ];

  const parmKey = "al1AccumulationCodeLst";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/al1AccumulationCodeLst`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteAccumulationCode = () => {
    if (selectedOption === "yes") {
      const params = { al1AccumulationCodeLst: rowData.al1AccumulationCodeLst };
      axios_helper_no_header(
        "DELETE",
        "api/al1AccumulationCodeLst",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter(
            (item) =>
              item.al1AccumulationCodeLst !== rowData.al1AccumulationCodeLst
          );
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          fetchData();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData, screenNumber: screenNumber };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/al1AccumulationCodeLst/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "initData") {
        const externalData = data?.data || {};
        setSelectedMode(data?.selectMode);
        setLookupType("external");
        setParamsData({
          al1AccumulationCodeLst:
            externalData?.paramsData?.al1AccumulationCodeLst || "",
        });
        setSelectParams(externalData?.params);
      }
    };
    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    selectMode,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAccumulationCode,
    setSelectedOption,
  };
};

export default useAccumulationCodeList;
